import { ValveType } from '@lib/api';
import * as yup from 'yup';
import i18n from 'i18next';

export const ValveTypeSchema = yup.object({
  valveType: yup.mixed<ValveType>().nullable().notOneOf([null]),
  description: yup.string().when('valveType', {
    is: (val: ValveType) => val === 'Other',
    then: (schema) => schema.required(i18n.t('required', { ns: 'common' })),
    otherwise: (schema) => schema.nullable(),
  }),
});
